import { atom } from 'jotai';

// Admin-only toggles to render the pre-customisation (main branch) version of the
// campaign Summary tab and the Dashboard. Default true = main version.
export const atom_useLegacySummary = atom<boolean>(true);
export const atom_useLegacyDashboard = atom<boolean>(true);
